import { Params } from "react-chatbotify";
import { getUserMessageApiCall } from "../../../store/chatbot.slice";
import { setBotInjector } from "../../../store/chatbotInjector";
import store from "../../../store/common/store";

export const CHAT_TEAM_ID = 10;
export const CHAT_MEMBER_ID = 303;

async function sendUserMessage(message: string, thread: string): Promise<void> {
  const response = await store.dispatch(
    getUserMessageApiCall(message, thread, CHAT_MEMBER_ID, CHAT_TEAM_ID)
  );

  return response;
}

export const createChatFlow = (thread: string) => ({
  start: {
    message: "Hey! How can I help you!",
    path: "loop",
  },
  loop: {
    message: async (param: Params) => {
      await sendUserMessage(param.userInput, thread);

      setBotInjector(param.injectMessage); // ✅ Register injector
      // your message sending logic here...
      return "";
    },
    path: "loop",
  },
});
